import { batch, observable } from "@legendapp/state";
import type { WebSearchCitation } from "@shared/schema";
import type { SourceContext } from "@/services/contextOrchestrator";

/** Same shape as ChatWorkspace `Message` / useChatSend `ChatSendMessage` (content string in UI). */
export type ChatThreadMessage = {
  id: string;
  role: "user" | "assistant";
  content: string;
  timestamp: Date;
  citations?: WebSearchCitation[];
  contextCitations?: Record<number, SourceContext>;
  images?: Array<{ url: string; detail?: string }>;
  model?: string;
  autoSelected?: boolean;
};

export const chatMessages$ = observable<ChatThreadMessage[]>([]);

